export default __webpack_public_path__ + "static/media/back.67f326fd.svg";